import { useSelector } from 'react-redux';

import { ViewTypeName } from '@air/api/types';

import { useShowExpandNestedContentToggle } from '~/components/ViewControls/ViewVisiblityToggleMenu/hooks/useShowExpandNestedContentToggle';
import { currentViewTypeNameSelector } from '~/store/configViews/selectors';

export type UseShowExpandNestedInVisibilityMenuParams = {
  isDisabled?: boolean;
};

/**
 * Gallery puts Expand beside the Boards header. Table and kanban have no section header, so the
 * toggle stays in the visibility menu. Private showcases stay in the menu even in gallery view.
 */
export const useShowExpandNestedInVisibilityMenu = ({
  isDisabled = false,
}: UseShowExpandNestedInVisibilityMenuParams = {}) => {
  const currentViewTypeName = useSelector(currentViewTypeNameSelector);
  const { showExpandNestedContentToggle } = useShowExpandNestedContentToggle({ isDisabled });

  return {
    showExpandNestedInVisibilityMenu: showExpandNestedContentToggle && currentViewTypeName !== ViewTypeName.gallery,
  };
};
